import { dashboardConstants } from "../_constants";

export function dashboardTopCard(state = {}, action) {
  switch (action.type) {
    case dashboardConstants.GET_TOP_CARDS_DASHBOARD_REQUEST:
      return {
        loading: true,
      };
    case dashboardConstants.GET_TOP_CARDS_DASHBOARD_SUCCESS:
      return {
        item: action.dashboard,
      };
    case dashboardConstants.GET_TOP_CARDS_DASHBOARD_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}
export function dashboardPieCharts(state = {}, action) {
  switch (action.type) {
    case dashboardConstants.GET_PIE_CHARTS_CARDS_DASHBOARD_REQUEST:
      return {
        loading: true,
      };
    case dashboardConstants.GET_PIE_CHARTS_CARDS_DASHBOARD_SUCCESS:
      return {
        item: action.dashboard,
      };
    case dashboardConstants.GET_PIE_CHARTS_CARDS_DASHBOARD_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function dailyJobRunTrackerData(state = {}, action) {
  switch (action.type) {
    case dashboardConstants.GET_DAILY_JOB_RUN_TRACKER_REQUEST:
      return {
        loading: true,
      };
    case dashboardConstants.GET_DAILY_JOB_RUN_TRACKER_SUCCESS:
      return {
        item: action.dashboard,
      };
    case dashboardConstants.GET_DAILY_JOB_RUN_TRACKER_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}

export function distinctConnections(state = {}, action) {
  switch (action.type) {
    case dashboardConstants.GET_DISTINCT_CONNECTIONS_REQUEST:
      return {
        loading: true,
      };
    case dashboardConstants.GET_DISTINCT_CONNECTIONS_SUCCESS:
      return {
        item: action.connections,
      };
    case dashboardConstants.GET_DISTINCT_CONNECTIONS_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}
